import { card, editor, iconAction, muted, readable, title, toolbar, type View } from "./components"

export type CommentEntry = {author: string, content: string, timestamp: number}

export function commentThread(entries: CommentEntry[], post?: (content: string) => Promise<void>): View {
  const input = editor("")
  input.style({minHeight: "76px", padding: "10px", font: "inherit"})
  input.setAttribute("aria-label", "Comment").setAttribute("placeholder", "Add a comment…")
  return card(
    title(`Comments (${entries.length})`).style({fontSize: "17px", marginTop: "0"}),
    post ? card(input, toolbar(iconAction("Post comment", "comment", async () => {
      const content = input.get().trim()
      if (!content) return
      await post(content)
      input.el.value = ""
    }))).style({background: "transparent", margin: "0 0 16px"}) : "",
    ...entries.map(entry => card(
      muted(`${entry.author} · ${new Date(entry.timestamp).toLocaleString()}`).style({marginTop: "0"}),
      readable(entry.content).style({marginBottom: "0"}),
    )),
    entries.length ? "" : muted("No comments yet."),
  ).setAttribute("class", "etindi-comments")
}
